<template>
  <span class="small fw-bold text-warning" title="Required" role="status">
    *
  </span>
</template>
